import styled from 'styled-components'
import { device } from 'src/theme/theme'

export const Box = styled.div`
  padding: 2rem;

  @media ${device.mobileL} {
    padding: 1rem;
  }

  @media (max-width: 1024px) {
    padding: 10px;
  }

  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${({ theme }) => theme.colors.palette.neutral300};

    @media (max-width: 1024px) {
      position: static;
      margin-top: -56.25%;
      background-color: #fff;
    }
  }

  .info {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    color: ${({ theme }) => theme.colors.palette.neutral600};
    padding: 0 1rem;

    @media ${device.mobileL} {
      margin-bottom: 1rem;
    }

    .icon {
      font-size: 3rem;

      @media ${device.mobileM} {
        font-size: 4.5rem;
      }

      @media ${device.tablet} {
        font-size: 6rem;
      }

      @media ${device.laptop} {
        font-size: 10rem;
      }
    }

    h2 {
      ${({ theme }) => theme.size.xs}

      @media ${device.mobileM} {
        ${({ theme }) => theme.size.md}
      }

      @media (min-width: 800px) and (max-width: 900px) {
        ${({ theme }) => theme.size.xs}
      }

      margin: 0.5rem 0;
    }

    p {
      ${({ theme }) => theme.size.xxs}
      max-width: 500px;

      @media ${device.laptop} {
        ${({ theme }) => theme.size.xs}
      }
    }
  }

  .button-login {
    ${({ theme }) => theme.size.xxs}
    @media ${device.laptop} {
      ${({ theme }) => theme.size.xs}
    }
  }
`
